import "./style.scss";
import * as React from "react";
import { Input as AntDInput, Icon } from "antd";

class PasswordInput extends React.Component<IPasswordInput, any> {
  constructor() {
    super();
    this.state = {
      hidePassword: true
    };
  }

  handleEyeClick() {
    const hidePassword = this.state.hidePassword;
    this.setState({ hidePassword: !hidePassword });
  }

  inputType() {
    if (this.props.disabled || this.state.hidePassword) {
      return "password";
    }
    return "text";
  }

  eyeType() {
    if (this.props.disabled || this.state.hidePassword) {
      return "eye";
    }
    return "eye-o";
  }

  eyeStyle(disabled: boolean) {
    var opacity = disabled ? 0.25 : 0.65;
    return "rgba(0, 0, 0," + opacity + ")";
  }

  render() {
    const { name, onChange, placeholder, disabled, value } = this.props;

    return (
      <AntDInput
        type={this.inputType()}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        name={name}
        size="large"
        value={value}
        suffix={
          <Icon
            type={this.eyeType()}
            style={{ color: this.eyeStyle(disabled), fontSize: 16 }}
            onClick={this.handleEyeClick.bind(this)}
          />
        }
      />
    );
  }
}

interface IPasswordInput {
  name?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: any) => void;
  disabled?: boolean;
}

export default PasswordInput;



// WEBPACK FOOTER //
// ./client/modules/form/PasswordInput/index.tsx